import { getCookie, setCookie, removeCookie } from "@analytics/cookie-utils";

export const get = (key: string) => getCookie(key);
export const set = (name: string, value: string, ttl?: number, path?: string, domain?: string, secure?: boolean) => setCookie(name, value, ttl, path, domain, secure);
export const remove = (key: string) => removeCookie(key);

export const delete_cookie = (name, path = '') => {
    document.cookie = name +`=; Path=/${path}; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
};

export const saveAppliedCouponCodeCookie = (couponCode) => {
    var valueOfCookie = 'type~' + couponCode + ';couponCode~' + couponCode + ';behaviour~AUTOAPPLY_AUTOFILLWITHAPPLY;bannerMessage~' + couponCode + ';showWebProspectPricing~true;';
    set('np.brandKeywordCampaign', valueOfCookie, 24 * 60 * 60 * 30 , '/');
};
export const getBrandKeywordCampaignParameters = (val) => {
    let pairs = unescape(val).split(';');
    let result = {};
    pairs.forEach(function (pair: any) {
        pair = pair.split('~');
        result[pair[0]] = decodeURIComponent(pair[1] || '');
    });
    return JSON.parse(JSON.stringify(result));
};

export const setCookieForSession = (name: string, value: string, path?: string) =>{
    document.cookie = `${name}=${encodeURIComponent(value)}; path=${path};`;
}
